import React from 'react';
import clsx from 'clsx';
import IconLink from '@/assets/icons/icon-link-01.svg?react';
import IconUnlink from '@/assets/icons/icon-unlink-01.svg?react';
import { IconSimpleButton } from '@/components/buttons/IconSimpleButton/IconSimpleButton';
import { Tooltip } from '@/components/tooltips/Tooltip/Tooltip';

interface InspectorHeaderProps {
  className: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  text: string;
  showStyle?: boolean;
  applied?: boolean;
  onToggleGlobalStyle?: () => void;
}

export const InspectorHeader: React.FC<InspectorHeaderProps> = ({
  className,
  icon: Icon,
  text = 'Image',
  showStyle = false,
  applied = false,
  onToggleGlobalStyle,
}) => {
  const handleToggleApplied = () => {
    onToggleGlobalStyle?.();
  };

  return (
    <div className={clsx('', className)}>
      <div className="bg-neutral-0 inline-flex h-13 w-full items-center justify-between self-stretch border-b border-neutral-100 px-3">
        <div className="flex items-center justify-start gap-1">
          {Icon && <Icon className="relative h-4.5 w-4.5 text-neutral-900" />}

          <p className="text-heading-ms justify-start font-semibold text-neutral-900">{text}</p>
          {showStyle && (
            <Tooltip
              position="bottom"
              textFirst={
                applied
                  ? 'Applied Style: Techy\nClick to detach element.'
                  : 'No Style Applied\nClick to apply style.'
              }
              textSecond={''}
              className={''}
              children={
                <IconSimpleButton
                  tooltipShow={false}
                  icon={applied ? IconUnlink : IconLink}
                  onClick={handleToggleApplied}
                  data-qa-selector="inspector-header-toggle-style-button"
                />
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};
